import { TimelineItem } from 'lib/Timeline';
import ListWithDivider from '../ListWithDivider';
import { LineLocation } from '../Location/Location.types';

const Location = ({
  countries = [],
  cities = [],
  streets = [],
  counties = [],
  postCodes = [],
}: Partial<LineLocation>): React.ReactElement => (
  <TimelineItem
    title={
      <p className="sub-header-base text-neutral-950-opacity-80" data-test-id="timeline-location-header">
        Location
      </p>
    }
  >
    <div
      className="grid grid-cols-2 gap-x-4 gap-y-1 body-sm text-neutral-950-opacity-80"
      data-test-id="timeline-location-list"
    >
      <p>Country</p>
      <ListWithDivider list={countries} dataTestId="location-countries-list" />
      <p>City</p>
      <ListWithDivider list={cities} dataTestId="location-cities-list" />
      <p>Street</p>
      <ListWithDivider list={streets} dataTestId="location-streets-list" />
      <p>County/State/Province</p>
      <ListWithDivider list={counties} dataTestId="location-counties-list" />
      <p>Postcode</p>
      <ListWithDivider list={postCodes} dataTestId="location-postcodes-list" />
    </div>
  </TimelineItem>
);

export default Location;
